/* ============================================================================
   SNAPGOODY — SHOPIFY BEHAVIOUR
   Cart (Shopify AJAX API) · design upload · product page · Fitting Room page ·
   homepage Fitting Room module.
   Markup is rendered by Liquid; this file only attaches behaviour, so the
   storefront stays crawlable and the theme editor stays in charge of content.
   ========================================================================== */
(function (global) {
  'use strict';
  var SG = global.SG;
  var $ = SG.$, $$ = SG.$$;
  var shop = global.SG_SHOP || {};
  var routes = shop.routes || {};

  /* ============================================================ MONEY ========
     Shopify already prices in the presentment currency; format with its own
     money_format so the storefront and the checkout agree.
     ======================================================================== */
  var fmt = shop.moneyFormat || '£{{amount}}';
  SG.money = function (cents) {
    var v = (cents / 100);
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, v.toFixed(2))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(v).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, v.toFixed(2).replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(v).toString());
  };

  /* =========================================================== DESIGN UPLOAD ==
     A print file is far too large for a line-item property, so it is uploaded
     first and only its id/URL travels with the cart line.

     Point settings.design_endpoint at an app proxy (for example
     /apps/snapgoody/designs) that accepts:

       POST { product, market, options, surfaces: { <id>: {
                widthMM, heightMM, dpi, px, background, layers,
                printDataUrl, previewDataUrl } } }

     and responds with:

       { id, previewUrl, printUrls: { <surfaceId>: "https://…" } }

     Without an endpoint the theme runs in preview mode: the design travels as
     a compact JSON spec and the shopper still sees their preview, but no print
     file is stored. Wire the endpoint before taking live orders.
     ======================================================================== */
  function uploadDesign(pkg) {
    if (!shop.designEndpoint) {
      return Promise.resolve({
        id: 'preview-' + Date.now().toString(36),
        previewUrl: pkg.preview,
        printUrls: {},
        stored: false
      });
    }
    return fetch(shop.designEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        product: pkg.product,
        market: pkg.market,
        options: pkg.options,
        surfaces: pkg.surfaces
      })
    })
      .then(function (r) { if (!r.ok) throw new Error('design upload failed: ' + r.status); return r.json(); })
      .then(function (j) { j.stored = true; return j; })
      .catch(function (e) {
        console.error('[snapgoody]', e);
        SG.toast('We could not save your design file — please try again.', 'alert');
        return { id: null, previewUrl: pkg.preview, printUrls: {}, stored: false };
      });
  }

  /* Compact spec that fits comfortably in a line-item property. */
  function specOf(pkg, upload) {
    var s = {
      v: 1,
      designId: upload.id,
      product: pkg.product,
      market: pkg.market,
      surfaces: {}
    };
    Object.keys(pkg.surfaces || {}).forEach(function (k) {
      var f = pkg.surfaces[k];
      s.surfaces[k] = {
        mm: [f.widthMM, f.heightMM],
        px: [f.px.w, f.px.h],
        dpi: f.dpi,
        bg: f.background,
        print: (upload.printUrls || {})[k] || null,
        layers: (f.layers || []).map(function (l) {
          return l.type === 'text'
            ? { t: 't', x: r3(l.x), y: r3(l.y), s: r3(l.size), r: r3(l.rot), f: l.font, c: l.color, k: r3(l.tracking), h: r3(l.leading), v: l.text }
            : { t: 'i', x: r3(l.x), y: r3(l.y), w: r3(l.w), h: r3(l.h), r: r3(l.rot), o: r3(l.opacity), fl: l.filter, n: [l.nw, l.nh] };
        })
      };
    });
    return s;
  }
  function r3(n) { return Math.round((n || 0) * 1000) / 1000; }

  /* ================================================================== CART ==*/
  function api(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Cart error');
        return j;
      });
    });
  }

  function hydrate(shopifyCart) {
    var groups = {};
    var items = [];
    (shopifyCart.items || []).forEach(function (l) {
      var props = l.properties || {};
      var bundleId = props._sg_bundle;
      var item = {
        id: l.key,
        handle: l.handle,
        title: props._sg_title || l.product_title,
        price: l.final_price,
        qty: l.quantity,
        options: {},
        design: props._sg_preview ? { preview: props._sg_preview } : null,
        line: { shopifyVariantId: l.variant_id, market: SG.region },
        bundleId: bundleId || null,
        url: l.url
      };
      (l.options_with_values || []).forEach(function (o) { item.options[o.name] = o.value; });

      if (bundleId) {
        if (groups[bundleId]) {
          /* Second half of a pair — fold its price in, keep one visible line. */
          groups[bundleId].price += l.final_price;
          groups[bundleId].bundleKeys.push(l.key);
          return;
        }
        item.bundleKeys = [l.key];
        item.title = props._sg_title || l.product_title;
        groups[bundleId] = item;
      }
      items.push(item);
    });
    SG.cart.items = items;
    SG.cart.shopify = shopifyCart;
  }

  function refresh() {
    return fetch(routes.cart, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { hydrate(c); SG.cart.sync(); return c; })
      .catch(function (e) {
        /* A failed cart read must not take the page down with it. Keep what we
           already have in memory and let the shopper carry on; the next add or
           page load re-syncs. */
        console.warn('[snapgoody] could not read the cart:', e && e.message);
        SG.cart.sync();
        return null;
      });
  }

  /* ══════════════════════════════════════ PERSONALISATION REQUIRED ══
     A piece made from the customer's own design has nothing to print until
     they have put something on it. Opening the studio is not enough, and
     neither is saving an empty one — so the test is whether any surface
     actually carries a layer.

     The check sits on SG.cart.add rather than on one button, because a
     product can reach the bag from the product page, the Fitting Room and the
     recommendation pop-up. One choke point, no path missed.

     Wording comes from Theme settings → Studio.
     ================================================================== */
  function designHasContent(pkg) {
    if (!pkg) return false;
    var surfaces = pkg.surfaces || {};
    return Object.keys(surfaces).some(function (k) {
      var s = surfaces[k] || {};
      return (s.layers || []).length > 0;
    });
  }

  var needModal = null;
  function needDesign(onFix) {
    var s = SG.studio || {};
    if (!needModal) {
      needModal = SG.el('div', { class: 'needdesign', 'data-needdesign': '' },
        '<div class="needdesign__scrim" data-need-close></div>' +
        '<div class="needdesign__panel" role="dialog" aria-modal="true" aria-labelledby="need-title">' +
          '<button class="needdesign__close" type="button" data-need-close aria-label="Close">' +
            SG.icon('close') + '</button>' +
          '<span class="needdesign__mark">' + SG.icon('wand') + '</span>' +
          '<h3 id="need-title" data-need-title></h3>' +
          '<p data-need-body></p>' +
          '<div class="needdesign__actions">' +
            '<button class="btn btn--clay" type="button" data-need-go></button>' +
            '<button class="link" type="button" data-need-close></button>' +
          '</div>' +
        '</div>');
      document.body.appendChild(needModal);
      SG.$$('[data-need-close]', needModal).forEach(function (b) {
        b.addEventListener('click', function () { closeNeed(); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && needModal.classList.contains('is-open')) closeNeed();
      });
    }
    SG.$('[data-need-title]', needModal).textContent = s.requireTitle || 'Personalise this piece first';
    SG.$('[data-need-body]', needModal).textContent = s.requireBody || '';
    var go = SG.$('[data-need-go]', needModal);
    go.textContent = s.requireCta || 'Personalise it now';
    SG.$$('[data-need-close]', needModal).forEach(function (b) {
      if (b.classList.contains('link')) b.textContent = s.requireDismiss || 'Not yet';
    });
    go.onclick = function () { closeNeed(); if (typeof onFix === 'function') onFix(); };
    needModal.classList.add('is-open');
    SG.lockScroll(true);
    setTimeout(function () { go.focus(); }, 60);
  }
  function closeNeed() {
    if (!needModal) return;
    needModal.classList.remove('is-open');
    SG.lockScroll(false);
  }
  SG.needDesign = needDesign;
  SG.designHasContent = designHasContent;

  /* ──────────────────────────────────────────────────────────────────────────
     A blocked add has to look blocked everywhere.

     Three of the add paths live in shop.js, which is shared byte for byte with
     the static build and must not be forked. Each of them does the same thing
     straight after calling cart.add: close the designer, open the "added to
     your bag" pop-up, raise a toast. None of them looks at the return value,
     so a blocked add would still be congratulated.

     Rather than fork shop.js, the three functions are wrapped here. The flag is
     cleared on the next tick, so it only ever suppresses the calls made in the
     same click — nothing later is affected.
     ───────────────────────────────────────────────────────────────────────── */
  var addBlocked = false;
  function blockAdd(onFix) {
    addBlocked = true;
    needDesign(onFix);
    setTimeout(function () { addBlocked = false; }, 0);
  }

  (function wrapAfterAdd() {
    if (SG.recommend && typeof SG.recommend.open === 'function') {
      var recOpen = SG.recommend.open;
      SG.recommend.open = function () {
        if (addBlocked) return;          /* nothing was added — nothing to cross-sell */
        return recOpen.apply(SG.recommend, arguments);
      };
    }
    if (typeof SG.closeDesigner === 'function') {
      var closeDesigner = SG.closeDesigner;
      SG.closeDesigner = function () {
        /* Keep them in the designer they are one step from finishing. */
        if (addBlocked) return;
        return closeDesigner.apply(this, arguments);
      };
    }
    if (typeof SG.toast === 'function') {
      var toast = SG.toast;
      SG.toast = function () {
        if (addBlocked) return;          /* no "added to your bag" for an add that failed */
        return toast.apply(SG, arguments);
      };
    }
  }());

  /* Replace the in-memory cart with the Shopify one. ---------------------- */
  SG.cart.add = function (product, o) {
    o = o || {};
    var studio = SG.studio || {};
    if (studio.requireDesign !== false && product && product.personalisable !== false
        && !designHasContent(o.design)) {
      blockAdd(o.onPersonalise);
      return null;
    }
    var line = SG.catalog.lineFor(product, SG.region, o.options);
    var qty = o.qty || 1;

    var doAdd = function (upload) {
      var spec = o.design ? specOf(o.design, upload) : null;
      var shared = {};
      if (spec) {
        shared['_sg_design'] = JSON.stringify(spec).slice(0, 4000);
        shared['_sg_preview'] = upload.previewUrl || '';
        shared['Personalised'] = 'Yes';
        if (upload.id) shared['_sg_design_id'] = upload.id;
      }

      var items;
      if (line.components && line.components.length) {
        /* A pair: two supplier products, one purchase. They share a bundle id
           so the cart, the drawer and the order all treat them as one item. */
        var bundleId = 'sgb-' + Date.now().toString(36);
        items = line.components.map(function (c, i) {
          var props = Object.assign({}, shared, {
            _sg_bundle: bundleId,
            _sg_bundle_part: c.key,
            _sg_title: product.title
          });
          if (i > 0) props._sg_hidden = 'true';
          return { id: c.shopifyVariantId, quantity: qty, properties: props };
        }).filter(function (i) { return i.id; });
      } else {
        items = [{ id: line.shopifyVariantId, quantity: qty, properties: shared }];
      }

      if (!items.length || !items[0].id) {
        SG.toast('This piece is not available in your region yet.', 'alert');
        return Promise.reject(new Error('no variant'));
      }
      return api(routes.cartAdd, { items: items }).then(refresh);
    };

    var p = o.design ? uploadDesign(o.design).then(doAdd) : doAdd({ id: null, previewUrl: '', printUrls: {} });
    p.catch(function (e) { console.error('[snapgoody]', e); SG.toast(e.message || 'Could not add to bag.', 'alert'); });

    /* Optimistic local line so the recommendation pop-up can open at once. */
    var optimistic = {
      id: 'pending', handle: product.handle, title: product.title,
      price: product.price, qty: qty, options: o.options || {}, design: o.design || null, line: line
    };
    return optimistic;
  };

  SG.cart.remove = function (key) {
    var item = SG.cart.items.filter(function (i) { return i.id === key; })[0];
    var keys = (item && item.bundleKeys) || [key];
    var chain = Promise.resolve();
    keys.forEach(function (k) {
      chain = chain.then(function () { return api(routes.cartChange, { id: k, quantity: 0 }); });
    });
    chain.then(refresh).catch(function (e) { console.error(e); });
  };

  SG.cart.setQty = function (key, q) {
    var item = SG.cart.items.filter(function (i) { return i.id === key; })[0];
    var keys = (item && item.bundleKeys) || [key];
    var chain = Promise.resolve();
    keys.forEach(function (k) {
      chain = chain.then(function () { return api(routes.cartChange, { id: k, quantity: Math.max(1, q) }); });
    });
    chain.then(refresh).catch(function (e) { console.error(e); });
  };

  SG.cart.checkout = function () { global.location.href = '/checkout'; };

  /* ========================================================== PRODUCT PAGE ==*/
  function initProduct() {
    var root = $('[data-pdp]');
    if (!root) return;
    var handle = root.getAttribute('data-handle');
    var product = SG.catalog.get(handle);
    if (!product) return;

    var state = { options: {}, qty: 1, design: null };
    SG.catalog.optionsFor(product, SG.region).forEach(function (o) { state.options[o.name] = o.values[0]; });
    $$('[data-opt].is-active', root).forEach(function (b) {
      state.options[b.getAttribute('data-opt')] = b.getAttribute('data-val');
    });
    $$('[data-optsel]', root).forEach(function (sel) {
      state.options[sel.getAttribute('data-optsel')] = sel.value;
    });

    /* gallery */
    $$('[data-thumb]', root).forEach(function (t, i) {
      t.addEventListener('click', function () {
        $$('[data-thumb]', root).forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var stage = $('[data-stage]', root);
        var src = t.getAttribute('data-src');
        if (stage && src) stage.innerHTML = '<img src="' + src + '" alt="' + SG.esc(product.title) + '">';
      });
    });

    /* options — buttons for short lists, a grouped select for long ones */
    function setOption(name, value) {
      state.options[name] = value;
      var out = $('[data-optval="' + name + '"]', root);
      if (out) out.textContent = value;

      var notes = (product.optionNotes || {})[name] || {};
      var noteEl = $('[data-optnote="' + name + '"]', root);
      if (noteEl) {
        noteEl.hidden = !notes[value];
        if (notes[value]) $('span', noteEl).textContent = notes[value];
      }

      if (editor) {
        editor.options[name] = value;
        editor.applyOptionBackgrounds();
        editor.paintPhotoPane();
      }
      syncPrice();
    }
    $$('[data-opt]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var name = b.getAttribute('data-opt');
        $$('[data-opt="' + name + '"]', root).forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        setOption(name, b.getAttribute('data-val'));
      });
    });
    $$('[data-optsel]', root).forEach(function (sel) {
      sel.addEventListener('change', function () { setOption(sel.getAttribute('data-optsel'), sel.value); });
    });

    function currentVariant() {
      var wanted = SG.catalog.optionsFor(product, SG.region).map(function (o) { return state.options[o.name]; });
      return (product.variants || []).filter(function (v) { return v.options.join('|') === wanted.join('|'); })[0] || null;
    }
    function syncPrice() {
      var v = currentVariant();
      var price = v ? v.price : product.price;
      var t = $('[data-total]', root);
      if (t) t.textContent = SG.money(price * state.qty);
      var pr = $('[data-pdp-price]', root);
      if (pr) pr.textContent = SG.money(price);
      var add = $('[data-add]', root);
      if (add) add.disabled = v ? !v.available : false;
    }

    /* quantity */
    $$('[data-qty]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        state.qty = Math.max(1, state.qty + (+b.getAttribute('data-qty')));
        var i = $('[data-qty-input]', root); if (i) i.value = state.qty;
        syncPrice();
      });
    });

    /* the inline Product Editor */
    var editor = null;
    var mount = $('[data-pdp-editor]');
    if (mount && product.personalisable) {
      editor = new SG.Editor(mount, {
        product: product,
        mode: 'compact',
        allowProductSwitch: false,
        doneLabel: 'Save design',
        onDone: function (pkg) {
          state.design = pkg;
          showDesign(pkg);
          SG.toast('Design saved to this item.', 'check');
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
      Object.keys(state.options).forEach(function (k) { editor.options[k] = state.options[k]; });
      applyGuideSettings(editor);
      mountAreaReadout(editor);
    }

    function jumpToEditor() {
      var band = $('[data-pdpeditor]');
      if (!band) return;
      band.scrollIntoView({ behavior: 'smooth', block: 'start' });
      band.classList.remove('is-flash'); void band.offsetWidth; band.classList.add('is-flash');
    }
    var openBtn = $('[data-open-editor]', root);
    if (openBtn) openBtn.addEventListener('click', jumpToEditor);

    function showDesign(pkg) {
      var host = $('[data-design-state]', root);
      if (!host) return;
      host.classList.add('is-on');
      host.innerHTML =
        '<div class="media"><img src="' + pkg.preview + '" alt="Your design"></div>' +
        '<div><strong>Your design is saved</strong><span>' +
          Object.keys(pkg.surfaces).length + ' printed face' + (Object.keys(pkg.surfaces).length > 1 ? 's' : '') +
          ' · ' + (pkg.warnings.length ? pkg.warnings.length + ' note' + (pkg.warnings.length > 1 ? 's' : '') : 'print-ready') +
        '</span></div><button type="button" data-edit-design>Edit</button>';
      $('[data-edit-design]', host).addEventListener('click', jumpToEditor);
    }

    /* add to bag */
    var add = $('[data-add]', root);
    if (add) add.addEventListener('click', function () {
      /* SG.cart.add does the gating — it is the one path every add goes
         through — and returns null when it has shown the pop-up instead. */
      var item = SG.cart.add(product, {
        design: state.design, options: state.options, qty: state.qty,
        onPersonalise: jumpToEditor
      });
      if (item) SG.recommend.open(product, item);
    });

    syncPrice();
    SG.chrome.accordions(root);
  }

  /* ===================================================== FITTING ROOM PAGE ==*/
  function initFittingRoomPage() {
    var host = $('[data-studio]');
    if (!host) return;
    var handle = SG.query('p') || host.getAttribute('data-default') || (SG.catalog.products[0] || {}).handle;
    var product = SG.catalog.get(handle) || SG.catalog.products[0];
    if (!product) return;

    var editor = new SG.Editor(host, {
      product: product,
      mode: 'studio',
      doneLabel: 'Add to bag',
      onDone: function (pkg, ed) {
        /* null means the personalisation gate stopped it and showed the
           pop-up. Do not tick step 3, do not cross-sell — nothing was added. */
        var item = SG.cart.add(ed.product, { design: pkg, options: ed.options });
        if (!item) return;
        markStep(3);
        SG.recommend.open(ed.product, item);
      },
      onChange: function (ed) { if (ed.layers && ed.layers().length) markStep(2); }
    });
    SG.editor = editor;
    applyGuideSettings(editor);
    mountAreaReadout(editor);

    function markStep(n) { $$('.frstep').forEach(function (s, i) { s.classList.toggle('is-on', i < n); }); }
  }

  /* ================================================= HOMEPAGE FITTING ROOM ==*/
  function initFittingRoomModule() {
    var host = $('[data-fitroom]');
    if (!host) return;
    var select = $('[data-fr-product]', host);
    var start = $('[data-fr-start]', host);
    var name = $('[data-fr-name]', host);
    var mock = $('[data-fr-mock]', host);
    var art = $('.fitroom__art', host);

    function engage() { host.classList.add('is-engaged'); }
    ['mouseenter', 'focusin', 'click'].forEach(function (ev) { host.addEventListener(ev, engage); });
    if ('IntersectionObserver' in global) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio > 0.45) engage(); });
      }, { threshold: [0.45] }).observe(host);
    }

    function setProduct(h, fallbackSrc) {
      var p = SG.catalog.get(h);
      if (!p) return;
      if (select) select.value = h;
      /* Only rewrite the Liquid-rendered href when we have a real URL to put
         there — an empty href would silently reload the current page. */
      if (start) {
        var frUrl = SG.url('fitting-room.html?p=' + h);
        if (frUrl) start.setAttribute('href', frUrl);
        else start.removeAttribute('href');
      }
      if (name) name.textContent = p.title;
      var src = SG.mockupSrc(h) || fallbackSrc || '';
      if (mock) {
        mock.innerHTML = src
          ? '<div class="media media--fill"><img src="' + src + '" alt="' + SG.esc(p.title) + '"></div>'
          : SG.media('fitroom.stage', { className: 'media--fill', label: p.title + ' · studio mockup' });
      }
      var s = (p.surfaces || [])[0];
      if (s && art) {
        art.style.inset = 'auto';
        art.style.left = (s.area.x * 100) + '%';
        art.style.top = (s.area.y * 100) + '%';
        art.style.width = (s.area.w * 100) + '%';
        art.style.height = (s.area.h * 100) + '%';
      }
      engage();
    }

    $$('[data-cat]', host).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-cat]', host).forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        setProduct(b.getAttribute('data-example'), b.getAttribute('data-image'));
      });
    });
    if (select) select.addEventListener('change', function () {
      $$('[data-cat]', host).forEach(function (x) {
        x.classList.toggle('is-active', x.getAttribute('data-example') === select.value);
      });
      setProduct(select.value);
    });

    var first = $('[data-cat]', host);
    if (first) setProduct(first.getAttribute('data-example'), first.getAttribute('data-image'));
  }

  /* ========================================================= PRINT GUIDES ==*/
  /* Theme settings → Studio (or the Fitting Room section, which overrides it
     on that page) decides how the guides start out. None of this reaches into
     editor.js: the strength and the centre lines are CSS, and "start hidden"
     sets exactly the state the studio's own Hide button sets — so the shopper
     can still turn them back on. It is a default, not a lock. */
  function applyStudioChrome() {
    var s = SG.studio || {};
    var root = document.documentElement;
    var strength = Number(s.guideStrength);
    if (isFinite(strength) && strength > 0 && strength !== 100) {
      root.style.setProperty('--sg-guide-strength', (strength / 100).toFixed(3));
    } else {
      root.style.removeProperty('--sg-guide-strength');
    }
    root.classList.toggle('sg-no-center-guides', s.centerGuides === false);
  }

  function applyGuideSettings(editor) {
    if (!editor || (SG.studio || {}).showGuides !== false) return;
    editor.showGuides = false;
    if (editor.el && editor.el.guides) editor.el.guides.classList.add('is-hidden');
    var host = editor.mount || document;
    var off = $('[data-guides-off]', host), on = $('[data-guides-on]', host);
    if (off && on) { off.classList.add('is-active'); on.classList.remove('is-active'); }
  }

  /* ==================================================== PHOTO AREA READOUT ==*/
  /* Theme Editor only. Prints the live photo area for whatever piece and face
     the studio is showing — the four percentages you type into the "Photo
     areas" section, side by side with the millimetres they print at — so the
     numbers can be read off the thing being adjusted rather than guessed.
     Shoppers never see this: SG.designMode is false on the storefront. */
  function pc(n) { return (Math.round(n * 1000) / 10).toFixed(1) + '%'; }

  /* A print that wraps a cylinder — the mug, the water bottle. Its mockup shows
     only the front of the wrap, so the box is a window onto the print rather
     than the whole of it, and the two ratios are meant to differ. */
  function isWrap(s) { return String(s && s.id).toLowerCase() === 'wrap'; }

  function mountAreaReadout(editor) {
    if (!SG.designMode || !editor || !editor.el || !editor.el.viewport) return;
    var bar = SG.el('div', { class: 'sg-arearead', 'data-arearead': '' }, '');
    editor.el.viewport.parentNode.insertBefore(bar, editor.el.viewport.nextSibling);

    function paint() {
      var s;
      try { s = editor.surface(); } catch (e) { return; }
      if (!s || !s.area) return;
      var p = editor.product || {};
      var mock = (p.mock && p.mock.ratio) || 1;
      var drawn = (s.area.w * mock) / s.area.h;
      var print = s.widthMM / s.heightMM;
      var skew = Math.abs(drawn - print) / print;
      bar.innerHTML =
        '<span class="sg-arearead__k">Photo area</span>' +
        '<span><b>Left</b> ' + pc(s.area.x) + '</span>' +
        '<span><b>Top</b> ' + pc(s.area.y) + '</span>' +
        '<span><b>Width</b> ' + pc(s.area.w) + '</span>' +
        '<span><b>Height</b> ' + pc(s.area.h) + '</span>' +
        '<span class="sg-arearead__sep">prints ' + s.widthMM + ' × ' + s.heightMM + ' mm</span>' +
        (s.overridden ? '<span class="sg-arearead__tag">set by hand</span>' : '') +
        (isWrap(s)
          ? '<span class="sg-arearead__ok" title="The print wraps the whole piece; the mockup shows only the front of it, so this box is a window onto the print rather than the whole of it.">front of a wrap-round print</span>'
          : skew > 0.02
            ? '<span class="sg-arearead__warn" title="A photograph that fills this box on screen will print ' +
              (drawn > print ? 'squeezed' : 'stretched') + '. Match the box to ' +
              pc(print * s.area.h / mock) + ' wide, or to ' + pc(s.area.w * mock / print) + ' tall.">' +
              'shape is ' + (skew * 100).toFixed(0) + '% off the print</span>'
            : '<span class="sg-arearead__ok">matches the print shape</span>');
    }

    paint();
    /* refreshMock() rewrites the guide box's inline style on every product and
       face change, so watching it catches both without touching editor.js. */
    if (window.MutationObserver && editor.el.guides) {
      new MutationObserver(paint).observe(editor.el.guides, { attributes: true, attributeFilter: ['style'] });
    }
  }

  /* The storefront doctor's print-geometry table gains the resolved numbers,
     for the same reason — it lists every product at once. */
  function fillDoctorGeometry() {
    var cells = $$('[data-geo-live]');
    if (!cells.length) return;
    cells.forEach(function (td) {
      var p = SG.catalog.get(td.getAttribute('data-geo-live'));
      if (!p || !(p.surfaces || []).length) { td.textContent = '—'; return; }
      td.innerHTML = p.surfaces.map(function (s) {
        var mock = (p.mock && p.mock.ratio) || 1;
        var drawn = (s.area.w * mock) / s.area.h, print = s.widthMM / s.heightMM;
        var off = Math.abs(drawn - print) / print;
        return '<div class="sg-doctor__sub"><code>' + SG.esc(s.id) + '</code> ' +
          pc(s.area.x) + ' / ' + pc(s.area.y) + ' · ' + pc(s.area.w) + ' × ' + pc(s.area.h) +
          ' <span class="sg-doctor__via">' + s.widthMM + ' × ' + s.heightMM + ' mm</span>' +
          (isWrap(s) ? ' <span class="sg-doctor__via">front of a wrap-round print</span>'
                     : off > 0.02 ? ' <span class="sg-doctor__warn">shape ' + (off * 100).toFixed(0) + '% off</span>' : '') +
          (s.overridden ? ' <span class="sg-doctor__ok">set by hand</span>' : '') +
          '</div>';
      }).join('');
    });
  }

  /* ================================================================== BOOT ==*/
  function boot() {
    applyStudioChrome();
    SG.chrome.boot();
    SG.bindCards();
    initFittingRoomModule();
    initProduct();
    initFittingRoomPage();
    refresh();
    SG.reveal();
    fillDoctorGeometry();

    /* Shopify theme editor: re-bind when a section is re-rendered. */
    document.addEventListener('shopify:section:load', function () {
      SG.bindCards();
      initFittingRoomModule();
      SG.reveal();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

}(window));

/* ── Content pages ────────────────────────────────────────────────────────────
   Shopify's rich text emits bare <table> elements. Wrap them so a wide delivery
   table scrolls inside its own box instead of stretching the page sideways. */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var body = document.querySelector('.pagebody.rte');
    if (!body) return;
    Array.prototype.forEach.call(body.querySelectorAll('table'), function (tb) {
      if (tb.parentNode.classList.contains('pagetable__scroll')) return;
      var w = document.createElement('div');
      w.className = 'pagetable__scroll';
      tb.parentNode.insertBefore(w, tb);
      w.appendChild(tb);
    });
  });
}());

/* ── Region selector ──────────────────────────────────────────────────────────
   Three options — UK, EU, US — exactly as the original storefront. Each option
   carries the representative country for that region, so changing it switches
   the real Shopify market and the page reloads with that market's pricing,
   currency and market-scoped products. */
(function () {
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.hasAttribute || !sel.hasAttribute('data-region-shopify')) return;
    var form = sel.form || sel.closest('form');
    if (!form) return;
    var opt = sel.options[sel.selectedIndex];
    var region = opt && opt.getAttribute('data-sg-region');
    if (region && SG && SG.toast && SG.regions[region]) {
      SG.toast('Switching to ' + SG.regions[region].label + '…', 'globe');
    }
    form.submit();
  }, true);
}());
